import { render, staticRenderFns } from "./VvSectionTitle.vue?vue&type=template&id=2738d1b9&scoped=true&"
import script from "./VvSectionTitle.vue?vue&type=script&lang=js&"
export * from "./VvSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./VvSectionTitle.vue?vue&type=style&index=0&id=2738d1b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2738d1b9",
  null
  
)

export default component.exports